<template>
  <div class="tq-input">
    <el-input v-bind="attrs">
      <template v-for="(_, name) in slots" >
        <slot :name="name"></slot>
      </template>
    </el-input>
  </div>
</template>

<script lang="ts" setup>
defineOptions({
  name: "TqInput",
});
import { getCurrentInstance } from "vue";

const instance = getCurrentInstance()?.proxy;

const slots = instance?.$slots;

const attrs = instance?.$attrs;
</script>
